import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  replaceTray: {
    position: "absolute",
    top: "8px",
    right: "8px",
    padding: "4px 8px",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    backgroundColor: "#7470708a",
    cursor: "pointer",
    zIndex: 2,
  },
  chooseTray: {
    borderRadius: "15px",
    cursor: "pointer",
    height: "192px",
    backgroundColor: theme?.palette?.customColor?.INPUT,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
  cashedContainer: {
    borderRadius: "50%",
    backgroundColor: "#fff",
    width: "25px",
    height: "25px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "auto",
  },
  arrowUpContainer: {
    width: "40px",
    height: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  chooseTextContainer: {
    justifyContent: "center",
    alignItems: "center",
    color: theme?.palette?.customColor?.SECONDARY,
  },
  blackColor: {
    color: theme?.palette?.customColor?.PRIMARY,
  },
  whiteColor: {
    color: theme?.palette?.customColor?.LIGHT,
  },
}));
